import toQueryParams from '../../utils/toQueryParams';
import claimScoreApiServiceClient from '../client';
import { ClaimScoreApiVersion } from '../types';
import { getClientForVersion } from '../utils';
import {
  CreateCasePayload,
  CreateCaseResponse,
  GetCaseAccountsResponse,
  GetCaseAggregateResultsPayload,
  GetCaseAggregateResultsResponse,
  GetCaseResponse,
  GetClaimDeterminationResultsPayload,
  GetClaimDeterminationResultsResponse,
  UpdateCasePayload,
} from './types';

export const getCaseById = async (caseId: string): Promise<GetCaseResponse> => {
  const client = getClientForVersion(ClaimScoreApiVersion.V2_5);
  const { data } = await client.get(`/cases/${caseId}`);
  return data;
};

export const getCaseAccounts = async ({
  accountRole,
  accountStatus,
  caseId,
  pageNumber,
  search,
}: {
  accountRole?: string;
  accountStatus?: string;
  caseId: string;
  pageNumber: number;
  search?: string;
}): Promise<GetCaseAccountsResponse> => {
  const { data } = await claimScoreApiServiceClient.get(
    `/cases/${caseId}/accounts?${toQueryParams({
      accountRole,
      accountStatus,
      pageNumber,
      pageSize: 12,
      search,
    })}`,
  );

  return data;
};

export const getClaimDeterminationResults = async ({
  caseID,
  pageNumber,
  pageSize,
  filters,
  sortOrder,
  sortField,
}: GetClaimDeterminationResultsPayload): Promise<GetClaimDeterminationResultsResponse> => {
  const client = getClientForVersion(ClaimScoreApiVersion.V2_5);
  const { data } = await client.post(
    `/cases/${caseID}/results?${toQueryParams({ pageNumber, pageSize, sortOrder, sortField })}`,
    { filters },
  );

  return data;
};

export const getCaseAggregateResults = async ({
  caseID,
  filters,
}: GetCaseAggregateResultsPayload): Promise<GetCaseAggregateResultsResponse> => {
  const client = getClientForVersion(ClaimScoreApiVersion.V2_5);
  const { data } = await client.post(`/cases/${caseID}/aggregate`, { filters });

  return data;
};

export const createCase = async ({
  organizationID,
  version,
  ...casePayload
}: CreateCasePayload): Promise<CreateCaseResponse> => {
  const client = version
    ? getClientForVersion(version)
    : claimScoreApiServiceClient;
  const { data } = await client.post(
    `/cases/organizations/${organizationID}`,
    casePayload,
  );

  return data;
};

export const updateCase = async ({
  caseID,
  version,
  ...casePayload
}: UpdateCasePayload): Promise<string> => {
  const client = version
    ? getClientForVersion(version)
    : claimScoreApiServiceClient;
  const { data } = await client.put(`/cases/${caseID}`, casePayload);
  return data;
};

export const deleteCase = async (caseID: string): Promise<string> => {
  const { data } = await claimScoreApiServiceClient.delete(`/cases/${caseID}`);
  return data;
};
